import { shaderMaterial } from '@react-three/drei';
import { Color } from 'three';

const vertexShader = `
  uniform float pointSize;
  uniform float distance;
  // 높이 자르기(VPF-5485). 켜져 있으면 데이터 좌표 z 가 maxHeight 이상인 점을 그리지 않습니다.
  uniform bool heightCutEnabled;
  uniform float maxHeight;

  void main() {
    if (heightCutEnabled && position.z >= maxHeight) {
      // 클립 공간 밖(z/w = 2)으로 보내 래스터화 전에 버립니다.
      gl_Position = vec4(0.0, 0.0, 2.0, 1.0);
      gl_PointSize = 0.0;
      return;
    }

    float effectivePointSize =  pointSize / distance;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    gl_PointSize = max(effectivePointSize, 1.0);
  }
`;

const fragmentShader = `
  uniform vec3 color;
  uniform float opacity;
  void main() {
    gl_FragColor = vec4(color, opacity);
  }
`;

export const CustomPointsMaterial = shaderMaterial(
  {
    pointSize: 0.05,
    distance: 35,
    color: new Color(),
    heightCutEnabled: false,
    maxHeight: 0,
    opacity: 1,
    transparent: true,
  },
  vertexShader,
  fragmentShader,
);
